import { Container, Row } from "reactstrap";
import { Alert, LinkColorTitle, LinkLightColorTitle, UIKits } from "../../../constants";
import { AlertColorData, AlertLightColorData } from "../../../data/uiKits/Alert";
import AdditionalAlert from "./AdditionalAlert";
import AlertWithIcons from "./alertWithIcons";
import CommonLinkColor from "./CommonLinkColor";
import DismissingDarkAlert from "./DismissingDarkAlert";
import DismissingLightAlert from "./DismissingLightAlert";
import LeftBorderAlert from "./LeftBorderAlert";
import LiveAlert from "./LiveAlert";
import OutlineAlert from "./outlineAlert";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

const AlertContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Alert} parent={UIKits} />
      <Container fluid>
        <Row>
          <CommonLinkColor title={LinkColorTitle} data={AlertColorData} text/>
          <CommonLinkColor title={LinkLightColorTitle} data={AlertLightColorData} text/>
          <OutlineAlert />
          <AlertWithIcons />
          <DismissingDarkAlert />
          <DismissingLightAlert />
          <LiveAlert />
          <LeftBorderAlert />
          <AdditionalAlert />
        </Row>
      </Container>
    </>
  );
};
export default AlertContainer;
